import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  fetchCostObjs,
  fetchCostObj,
  deleteCostObj,
  resetDeleteFailed
} from 'redux/costObjs/CostObjsActions';
import CostObjsOperations from './CostObjsOperations';

const mapStateToProps = ({ costObjs }) => ({
  costObjs: costObjs.costObjs,
  totalEntries: costObjs.pageState.totalEntries,
  fetchingCostObjs: costObjs.fetchingCostObjs,
  errorMessage: costObjs.errorMessage
});

const mapDispatchToProps = dispatch => ({
  costObjsActions: bindActionCreators(
    { fetchCostObjs, fetchCostObj, deleteCostObj, resetDeleteFailed },
    dispatch
  )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CostObjsOperations);



// WEBPACK FOOTER //
// ./src/components/manageCostObjs/comp/costObjsOperations/CostObjsOperationsConnector.js